import { useSyncExternalStore } from 'react'
import {
  subscribeSurveyDraft,
  surveyDraftUnstored,
} from '@/helpers/surveyStorage'

/** True while this phone could not keep the survey draft. */
export function useSurveyStorageWarning(): boolean {
  return useSyncExternalStore(
    subscribeSurveyDraft,
    surveyDraftUnstored,
    () => false,
  )
}
